import VueCookies from 'vue-cookies'
import { validateToken } from '@/auth/auth.api'
import { authStore } from '@/store/auth'
import JwtDecode from 'jwt-decode'

const shouldBeAuthenticate = async (to, from, next) => {
  const shouldAutenticate = await requireAuth()
  if (shouldAutenticate) {
    window.open(
      `${process.env.VUE_APP_LOGIN_CAS_URL}/?service=${process.env.VUE_APP_API_BASE_URL}`,
      '_self'
    ) && next(false)
  } else {
    next(0)
  }
}

const requireAuth = async () => {
  if (!VueCookies.isKey(process.env.VUE_APP_COOKIE_NAME)) return true
  if (VueCookies.isKey('dispatch-login')) {
    VueCookies.remove('dispatch-login')
    authStore().login(JwtDecode(VueCookies.get(process.env.VUE_APP_COOKIE_NAME)))
    return false
  } else {
    try {
      const { data } = await validateToken()
      authStore().login(data)
      return false
    } catch (e) {
      return true
    }
  }
}

export {
  shouldBeAuthenticate
}
